import {
  APP_INITIALIZER,
  ApplicationConfig,
  inject,
  PLATFORM_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { firstValueFrom, timeout } from 'rxjs';

import { routes } from './app.routes';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LogInterceptor } from './interceptors/log.interceptor';

import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogManagerService } from './services/dialog-manager.service';
import { AuthService } from './services/auth.service';

// vor dem ersten Routing: Guards lesen die Rechte synchron
function loadUserAccess(): () => Promise<void> {
  const authService = inject(AuthService);
  const platformId = inject(PLATFORM_ID);

  return async () => {
    if (!isPlatformBrowser(platformId) || !authService.isLoggedIn()) return;
    try {
      await firstValueFrom(authService.loadAccess().pipe(timeout(5000)));
    } catch {
      // Guards leiten auf /access-error
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    // ohne withFetch(): FetchBackend meldet keinen Upload-Fortschritt; SSR wird nicht deployt (nur dist/browser)
    provideHttpClient(withInterceptors([AuthInterceptor, LogInterceptor])),
    { provide: APP_INITIALIZER, useFactory: loadUserAccess, multi: true },
    MessageService,
    DialogService,
    DialogManagerService,
  ],
};
